import React from 'react'
import { connect } from 'react-redux'
import { getFormValues, Field } from 'redux-form'
import {
  Fade,
} from '@material-ui/core'
import r from 'reactotron-react-js'

import { StdCard } from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'

import { 
  GRContainer,
} from 'routes/ProcurementSystem/GoodsServiceReceipt/styled'
import {
  Cont
} from './styled'

const Summary = props => {

  const { 
    valueForm,
  } = props

  return (
    <Fade in={true} timeout={1000}>
    <GRContainer>
      {valueForm&&
      <StdCard title='Summary Information'>
        {/* <Cont> */}
          <Field
            name='vendor'
            label='Vendor'
            editable={false}
            type={type.text}
            component={FieldInput}
            className='halfRow'
          />
          <Field
            name='title'
            label='Title'
            type={type.text}
            component={FieldInput}
            editable={false}
            tooltip
            className='halfRow'
          />
          <Field
            name='goaItemName'
            label='GOA'
            editable={false}
            component={FieldInput}
            type={type.text}
            className='halfRow'
          />
          {valueForm.advancePayment&&
          <Field
            name='advancePaymentNo'
            label='Advance Payment No.'
            type={type.text}
            component={FieldInput}
            editable={false}
            className='halfRow'
          />}
          {valueForm.isFinal&&
          <Field
            name='mainContractTotalValue'
            label='Main Contract Total Value'
            type={type.number}
            fixedDecimalScale={true}
            component={FieldInput}
            editable={false}
            className='halfRow'
            suffix={` ${valueForm.currencyCode}`}
          />}
          <Field
            name='totalInvoiceAmount'
            label='Total Invoice Amount'
            type={type.number}
            fixedDecimalScale={true}
            component={FieldInput}
            editable={false}
            className='halfRow'
            suffix={` ${valueForm.currencyCode}`}
          />
          <Field
            name='deductDownPayment'
            label='Deduct Down Payment / Advance Payment'
            type={type.number}
            fixedDecimalScale={true}
            component={FieldInput}
            editable={false}
            className='halfRow'
            suffix={` ${valueForm.currencyCode}`}
          />
          {valueForm.withholdingTaxRate!=null&&
          <Field
            name='withholdingTax'
            label={`Withholding Tax ${Number(valueForm.withholdingTaxRate)>0?`${Number(valueForm.withholdingTaxRate)}%`:valueForm.withholdingTaxRate===0?'Tax Exampted':'Amount'}`}
            type={type.number}
            fixedDecimalScale={true}
            component={FieldInput}
            editable={false}
            className='halfRow'
            suffix={` ${valueForm.currencyCode}`}
          />}
          <Field
            name='deductRetentionAmount'
            label={`Deduct Retention Warranty ${valueForm.deductRetentionRate?`(${valueForm.deductRetentionRate}%)`:''}`}
            type={type.number}
            fixedDecimalScale={true}
            component={FieldInput}
            editable={false}
            className='halfRow'
            suffix={` ${valueForm.currencyCode}`}
          />
          {valueForm&&valueForm.otherName1&&
            <Field
            name='otherValue1'
            label={`Other1 (${valueForm&&valueForm.otherName1})`}
            type={type.number}
            fixedDecimalScale={true}
            component={FieldInput}
            editable={false}
            className='halfRow'
            suffix={` ${valueForm.currencyCode}`}
          />}
          {valueForm&&valueForm.otherName2&&
            <Field
            name='otherValue2'
            label={`Other2 (${valueForm&&valueForm.otherName2})`}
            type={type.number}
            fixedDecimalScale={true}
            component={FieldInput}
            editable={false}
            className='halfRow'
            suffix={` ${valueForm.currencyCode}`}
          />}
          {valueForm&&valueForm.otherName3&&
            <Field
            name='otherValue3'
            label={`Other3 (${valueForm&&valueForm.otherName3})`}
            type={type.number}
            fixedDecimalScale={true}
            component={FieldInput}
            editable={false}
            className='halfRow'
            suffix={` ${valueForm.currencyCode}`}
          />}
          <Field
            name='vatAmount'
            label={`VAT ${valueForm&&valueForm.vatRate}%`}
            type={type.number}
            fixedDecimalScale={true}
            component={FieldInput}
            editable={false}
            className='halfRow'
            suffix={` ${valueForm.currencyCode}`}
          />
          <Field
            name='billingAmount'
            label='Net Amount after deduction'
            type={type.number}
            fixedDecimalScale={true}
            component={FieldInput}
            editable={false}
            className='halfRow'
            suffix={` ${valueForm.currencyCode}`}
          />
        {/* </Cont> */}
      </StdCard>}
    </GRContainer>
    </Fade>
  )   

}

const mapStateToProps = (state) => ({
  vendors:state.options.vendors,
  goas: state.goa.goas,
  valueForm: getFormValues('formGR')(state)
})

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(Summary)
